export default "mutation synchronize($openId: String,$enforce: Boolean!) {\n  synchronize(openId: $openId,enforce: $enforce) \n}";